import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

import moment from 'moment'

import constants from '../../constants'

class SubjectsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      description: '',
      subjectCategory: '',
      showModal: false,
      subjectId: ''
    };
  }

  handleChange = (e, { name, value }) => {
    if(name === 'name') {
      let code = value.replace(/\s/g, '')
      code = code + '-' + moment().format('MMDDYYYY')

      this.setState({ [name]: value, code:  code.toUpperCase() })
    } else {
      this.setState({ [name]: value })
    }
  }

  handleSubmit = () => {
    const data = {
      name: this.state.name,
      code: this.state.code,
      description: this.state.description,
      subjectCategory: this.state.subjectCategory,
      schoolYearId: this.props.subject.schoolYearId
    };
    this.props.handleUpdate(data,this.state.subjectId);
    this.setState({
      name: '',
      code: '',
      description: '',
      subjectCategory: '',
      showModal: false,
      subjectId: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      name: this.props.subject.name,
      code: this.props.subject.code,
      description: this.props.subject.description,
      subjectCategory: this.props.subject.subjectCategory,
      subjectId: this.props.subject.subjectId
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.subject.name,
      code: newProps.subject.code,
      description: newProps.subject.description,
      subjectCategory: newProps.subject.subjectCategory,
      subjectId: newProps.subject.subjectId
    })
  }

  render() {
    const optionsSubjectCategory= constants.subjectCategory;
    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='pencil' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Edit a Subject</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' disabled  className='subject-disabled'/>
            </Form.Group>

            <Form.Group widths='equal'>
              <Form.Select
                fluid
                search
                clearable
                name='subjectCategory'
                label='Subject Category'
                placeholder='Subject Category'
                options={optionsSubjectCategory}
                onChange={this.handleChange}
                value={this.state.subjectCategory}
              />
              <Form.Field control={Input} value={this.state.description} name='description' label='Description' placeholder='Description' onChange={this.handleChange}/>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SubjectsEdit;
